// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__2SYsC","time":"styles_time__1CtSm"};